import { Alert } from '@mantine/core';
import React from 'react';

export function UserQueryErrorBanner() {
  return (
    <Alert title='Fetching user failed!' color='red'>
      Try to refresh the page (or navigate away and back to this page) or logout and login again to your account! If the
      problem persists, please contact customer support! You can also try clearing your browser&apos;s cache and
      cookies.
    </Alert>
  );
}
